import { createFileRoute } from "@tanstack/react-router"
import { EditCommunicationTemplatePage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/communication/templates/$templateUuid"
)({
  component: function EditTemplateRoute() {
    const { templateUuid } = Route.useParams()
    return (
      <AuthorizationGate
        resource={Resource.COMMUNICATION_TEMPLATES}
        action={Action.UPDATE}
      >
        <EditCommunicationTemplatePage templateUuid={templateUuid} />
      </AuthorizationGate>
    )
  },
})
